<template lang="pug">
  v-container.View.View--Place
    template(v-if="!loading")
      v-card
        v-img.white--text(
          :src="location.coverImage"
          height="15rem"
          gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,.7)"
        )
          v-container(fill-height fluid)
            v-layout(fill-height align-end)
              .d-flex.align-center
                v-flex(xs12)
                  .subtitle-1 {{ categoryNameToPretty(location.mainCategory, this.categories) }}
                  .headline {{ location.name }}
        v-card-text.pa-0(style="color:rgba(0, 0, 0, 0.87)")
          // contacts
          div.text-center.d-flex.flex-wrap
            a.clean.d-inline-block.pa-3.Contact(style="flex: 1" :class="{ disabled: !location.phone }" :href="`tel:${location.phone}`")
              v-icon mdi-phone
              div Chiama
            a.clean.d-inline-block.pa-3.Contact(style="flex: 1" :class="{ disabled: !location.whatsapp }" :href="`https://wa.me/39${location.whatsapp}`")
              v-icon mdi-whatsapp
              div WhatsApp
            a.clean.d-inline-block.pa-3.Contact(style="flex: 1" :class="{ disabled: !location.email }" :href="`mailto:${location.email}`")
              v-icon mdi-email-outline
              div Mail
            a.clean.d-inline-block.pa-3(style="flex: 1" v-if="false")
              v-icon mdi-map
              div Mappa
          v-divider

          // list open
          .pa-3.d-flex.align-center.flex-wrap.justify-center(v-if="location.waitingList && location.waitingList.status == 'open'")
            div.flex-grow-1.mr-sm-3.text-center.text-sm-left
              div.font-weight-bold(:class="waitToColor(location) + '--text'") {{ location.waitingList.currentlyWaiting }} persone in coda
              div Tempo di attesa stimato:&nbsp;
                // span {{ delay(location) }} minuti
                span {{ formatWaitTime(location.waitingList.estimatedLastArrivalDate) }}
            div
            v-btn.secondary.my-3.my-sm-0(
                @click="checkAndReserve" :loading="loadingReserve" rounded
              )
              v-icon(left) mdi-calendar-check
              | Mettiti in lista
          // list closed/inactive
          .pa-3.text-center(v-else)
            v-btn.secondary.my-3.my-sm-0(
              disabled small rounded
            )
              v-icon(left) mdi-calendar-check
              | Mettiti in lista
            div Al momento questa attività non accetta nuovi clienti
          v-divider
          // preregistration
          .pa-3.d-flex.align-center.flex-wrap.justify-center
            div.flex-grow-1.mr-sm-3.text-center.text-sm-left
              div Effettua adesso la tua pre-registrazione
            div
              v-btn.secondary.my-3.my-sm-0(:loading="loadingReserve" rounded :to="{ name: 'preregister', params: { place: location.id } }")
                v-icon(left) mdi-check
                | Pre-registrati
          v-divider
          // description
          template(v-if="location.description")
            div.pa-3
              .d-flex.align-center
                div.mr-3
                  v-icon(large color="primary") mdi-information-outline
                .mr-3.flex-grow-1
                  .font-weight-medium.subtitle-1 Descrizione
                  div {{ location.description }}
            v-divider
          v-expansion-panels(accordion flat v-if="location.openingHours && location.openingHours.length == 7")
            v-expansion-panel
              v-expansion-panel-header.pa-3
                .d-flex.align-center
                  div.mr-3
                    v-icon(large color="primary") mdi-clock-outline
                  .mr-3.flex-grow-1
                    .font-weight-medium.subtitle-1 {{ slotsToPretty(location.openingHours[new Date().getDay()].slots) }}
                    .font-weight-regular.subtitle-2 {{ weekdays[new Date().getDay()] }}
              v-expansion-panel-content
                .d-flex(v-for="i in [1,2,3,4,5,6,0]")
                  .flex-grow-1 {{ weekdays[i] }}
                  div {{ slotsToPretty(location.openingHours[i].slots) }}
          v-divider
          template(v-if="location.website")
            a.clean.d-block.pa-3.d-flex.align-center(:href="`http://${location.website}`" target="_blank")
              div.mr-3
                v-icon(large color="primary") mdi-web
              .mr-3.flex-grow-1
                .font-weight-medium.subtitle-1 Sito Internet
                .font-weight-regular.subtitle-2 {{ location.website }}
          v-divider
          v-expansion-panels(accordion flat v-if="false")
            v-expansion-panel
              v-expansion-panel-header.pa-3
                .d-flex.align-center
                  div.mr-3
                    v-icon(large color="primary") mdi-tag
                  .mr-3.flex-grow-1
                    .font-weight-medium.subtitle-1 Offerte
                    .font-weight-regular.subtitle-2 3 disponibili
              v-expansion-panel-content
                p Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quasi exercitationem autem quam. Iusto expedita aperiam iure ipsa autem voluptas ratione voluptatem, veritatis aliquid facere odio reiciendis reprehenderit laudantium corporis commodi.

      v-alert.mt-3.elevation-2.cursor-pointer.white(type="info" outlined icon="mdi-help")
        a.d-block.clean(href="https://business.openlist.it" target="_blank")
          | Vorresti una pagina come questa per la tua attività?&nbsp;
          span.fake-link Clicca qui!

      v-dialog(v-model="showLoginDialog" max-width='720px')
        v-card(scrollable)
          v-card-title
            div Login
            v-spacer
            v-btn(icon @click="showLoginDialog=false")
              v-icon mdi-close
          v-card-text
            .subtitle-1.text-center Effettua il login per metterti in lista
            ValidationObserver(v-slot="{ invalid, validated, passes }")
              v-form
                v-layout(wrap)
                  v-flex(xs12)
                    ValidationProvider(name="Email" rules="required|email" v-slot="{ errors }")
                      v-text-field(
                        v-model="loginForm.email" required
                        :error-messages="errors"
                        name="e-mail" type="email"
                        label="Email" prepend-inner-icon="mdi-at"
                      )
                  v-flex(xs12)
                    ValidationProvider(name="Password" rules="required" v-slot="{ errors }")
                      v-text-field(
                        v-model="loginForm.password" required
                        :error-messages="errors"
                        name="password" type="password"
                        label="Password" prepend-inner-icon="mdi-asterisk"
                      )
                  v-flex(xs12)
                    v-btn.secondary(
                      @click="passes(loginAndReserve)" :disabled="invalid || !validated"
                      :loading="loadingLoginReserve" block rounded
                    ) Login
                  v-flex(xs12)
                    div.mt-2.text-center Non sei registrato?&nbsp;
                      router-link(:to="{ name: 'auth.register' }") Crea il tuo account
                  v-flex(xs12)
                    div.mt-2.text-center
                      router-link(:to="{ name: 'auth.login' }") Password dimenticata?
            v-divider.mt-3
            .text-center.mt-3
              .fake-link(
                @click='showLoginDialog=false;showReserveByEmailDialog=true'
              ) Non vuoi registrarti?

      v-dialog(v-model="showReserveByEmailDialog" max-width="720px")
        v-card(scrollable)
          v-card-title
            div Prenota con email
            v-spacer
            v-btn(icon @click="showReserveByEmailDialog=false")
              v-icon mdi-close
          v-card-text
            .subtitle-1.text-center Prenota un posto inserendo solo la tua email
            ValidationObserver(v-slot="{ invalid, validated, passes }")
              v-form
                v-layout(wrap)
                  v-flex(xs12)
                    ValidationProvider(name="Email" rules="required|email" v-slot="{ errors }")
                      v-text-field(
                        v-model="reserveEmailForm.email" required
                        :error-messages="errors"
                        name="e-mail" type="email"
                        label="Email" prepend-inner-icon="mdi-at"
                      )
                  v-flex(xs12)
                    ValidationProvider(name="Nome" rules="required" v-slot="{ errors }")
                      v-text-field(
                        v-model="reserveEmailForm.name" required
                        :error-messages="errors"
                        name="nome"
                        label="Nome" prepend-inner-icon="mdi-account"
                      )
                  v-flex(xs12)
                    ValidationProvider(name="Cognome" rules="required" v-slot="{ errors }")
                      v-text-field(
                        v-model="reserveEmailForm.surname" required
                        :error-messages="errors"
                        name="cognome"
                        label="Cognome" prepend-inner-icon="mdi-account"
                      )
                  v-flex(xs12)
                    v-btn.secondary(
                      @click="passes(reserveByEmail)" :disabled="invalid || !validated"
                      :loading="loadingReserve" block
                    ) Prenota con email
    template(v-else)
      Loading
</template>

<script>
import Loading from "@/components/Loading";
import Location from "@/api/LocationPublic";
import Category from "@/api/Category";
import Ticket from "@/api/TicketPublic";

import {
  delayToColor,
  delay,
  waitToColor,
  formatWaitTime
} from "@/utils/delayUtils";
import { weekdays, slotsToPretty } from "@/utils/timeslotsUtils";
import { categoryNameToPretty } from "@/utils/categoryUtils";

export default {
  name: "Location",
  components: { Loading },

  data: () => ({
    loading: true,
    loadingReserve: false,
    loadingLoginReserve: false,
    loadingEmailReserve: false,

    location: null,
    categories: null,

    showLoginDialog: false,
    showReserveByEmailDialog: false,

    loginForm: {
      email: "",
      password: ""
    },
    reserveEmailForm: {
      email: ""
    },
    weekdays
  }),

  async mounted() {
    this.loading = true;

    this.location = await Location.get(this.$route.params.place);
    this.$emit("update:title", this.location.name);
    this.categories = await Category.all();

    this.loading = false;
  },

  methods: {
    delayToColor,
    delay,
    slotsToPretty,
    categoryNameToPretty,
    waitToColor,
    formatWaitTime,

    async checkAndReserve() {
      if (this.$auth.check()) {
        await this.reserve();
      } else {
        this.showLoginDialog = true;
      }
    },

    async reserve() {
      this.loadingReserve = true;
      try {
        const ticket = await Ticket.create({
          waitingListId: this.location.waitingList.id
        });
        this.$router.push({
          name: "ticket",
          params: { ticket: ticket.id }
        });
      } catch (error) {
        this.loadingReserve = false;
        throw error;
      }
    },

    async loginAndReserve() {
      this.loadingLoginReserve = true;

      try {
        await this.$auth.login({
          username: this.loginForm.email,
          password: this.loginForm.password
        });
        await this.reserve();
      } catch (error) {
        this.loadingLoginReserve = false;
        throw error;
      }

      this.loadingLoginReserve = false;
    },

    async reserveByEmail() {
      this.loadingReserve = true;
      try {
        const ticket = await Ticket.createUnauthenticated({
          waitingListId: this.location.waitingList.id,
          ...this.reserveEmailForm
        });
        this.$router.push({
          name: "ticket",
          params: { ticket: ticket.id }
        });
      } catch (error) {
        this.loadingReserve = false;
        throw error;
      }
      this.loadingReserve = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.Contact {
  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>
